module.exports = global["Phaser"] = require("-!./phaser-split.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/phaser-split.js-exposed
// module id = 11
// module chunks = 1